<template>
  <section class="section section--member section--bg">
    <div class="container">
      <div class="title">
        出勤中
      </div>
      <p class="notification_text" v-if="recentLives.length <= 0">現在、出勤中のキャストはいません。</p>
      <ul class="columns is-multiline is-mobile">
        <LiveListedTile
          v-for="live in recentLives"
          :key="live.id"
          :tileData="{
            liveId: live.id,
            imageSrc: live.thumbnailURL,
            nickname: live.performerNickname,
            genre: live.categories,
            startAt: live.startAt,
            title: live.title,
            type: 'recentLive'
          }"
          :onClick="liveTileClicked"
        />
      </ul>
    </div>
  </section>
</template>

<script>
import { auth } from '@/plugins/firebase';
import { mapState } from 'vuex';
import LiveListedTile from '@/components/Molecules/LiveListedTile';
import { analyticsLog } from '@/utils/analytics';

const tilesNumber = 10000;

export default {
  name: 'LiveExplore',
  components: {
    LiveListedTile
  },
  computed: {
    ...mapState({
      recentLives: state => state.live.recentLives.slice(0, tilesNumber)
    })
  },
  async created() {
    const that = this;
    auth.onAuthStateChanged(user => {
      if (!user.emailVerified && !that.$route.path.includes('signup')) {
        that.$router.push('/user/created');
      }
    });

    await this.$store.dispatch('live/loadRecentLives');
    analyticsLog('配信一覧【表示時】');
  },
  methods: {
    liveTileClicked(id, type) {
      const path = `/live/streaming/${id}?type=${type}`;
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-explore.scss';
</style>
